import axios, { AxiosRequestConfig, CancelTokenSource } from 'axios'
import type { BookingQuotePriceBreakdown } from '@/models/common/breakdown'
import type { DateString, Integer } from '@/models/common/commons'
import config from '@/utils/config'

export interface BookingQuoteRoomConfiguration {
  identifier: Integer
  paymentPrice: number
  totalPrice: BookingQuotePriceBreakdown[]
}

interface BookingQuoteExternalProduct {
  id: Integer
  netPrice: number
  vat: number
  paymentPrice: number
  totalPrice: number
}

interface BookingQuoteFee {
  id: Integer
  totalPrice: number
  paymentPrice: number
}

interface BookingQuoteRequestParams {
  cancelToken?: CancelTokenSource
}

export interface BookingQuoteResponse {
  roomConfigurations: BookingQuoteRoomConfiguration[]
  optionalBookingFees: BookingQuoteFee[]
  optionalExternalProducts: BookingQuoteExternalProduct[]
  totalPrice: number
  paymentPrice: number
  isAvailableOnRequest: boolean
  extrasPaidOnArrival: number
  futurePayments?: Record<string, number>
}

export interface BookingQuoteRequest {
  propertyId: string
  checkin: DateString
  checkout: DateString
  roomConfigurations: BookingQuoteRequestRoomConfiguration[]
  optionalBookingFees?: Integer[]
  optionalExternalProducts: Record<string, number>
  session: string
}

export interface BookingQuoteRequestRoomConfiguration {
  paxAges: Integer[]
  extras?: Record<string, number>
  fees?: Integer[]
  identifier: Integer
  roomID: Integer
  ratePlanID: Integer
  boardCode: string
  physicalRoomID?: Integer
}

export async function getBookingQuote(req: BookingQuoteRequest, params: BookingQuoteRequestParams = {}) {
  const reqParams: AxiosRequestConfig = { baseURL: config.apiUrl! }
  if (params.cancelToken) {
    reqParams.cancelToken = params.cancelToken.token
  }

  return (await axios.post(
    `/book/v2/properties/${req.propertyId}/getbookingquote`,
    req,
    reqParams
  )).data as BookingQuoteResponse
}

export function generateCancelToken() {
  return axios.CancelToken.source()
}

export function cancelRequest(token: CancelTokenSource) {
  return token.cancel()
}
